/**
 * Synchronizes image compare sliders within section#tabs
 * When one slider moves, all others move to the same percentage position
 */

if(typeof Drupal !== 'undefined') {
  Drupal.behaviors.werkstueckspImgCompareSync = {
    attach(context) {
      initImgCompareSync(context);
    }
  }
} else {
  document.addEventListener('DOMContentLoaded', function() {
    initImgCompareSync(document);
  });
}

function initImgCompareSync(context) {
  const tabsSection = context.querySelector('section#tabs');
  if (!tabsSection) return;

  // Find all imgcompare instances within section#tabs
  const imgCompares = tabsSection.querySelectorAll('.image-compare--wrapper');
  if (imgCompares.length <= 1) return; // No need to sync if only one or none

  const instances = [];
  let isUpdatingFromSync = false;

  imgCompares.forEach(imgCompare => {
    const slider = imgCompare.querySelector('.image-compare--slider');
    const overlayImage = imgCompare.querySelector('.image-compare--overlay');

    if (!slider || !overlayImage) return;

    const instance = {
      imgCompare,
      slider,
      overlayImage,
      isSliding: false
    };

    instances.push(instance);

    // Use MutationObserver to detect when slider position changes
    const observer = new MutationObserver(() => {
      if (isUpdatingFromSync || !instance.isSliding) return;

      // Get current position as percentage
      const leftValue = slider.style.left;
      const position = parseFloat(leftValue) || 0;
      const width = imgCompare.offsetWidth;
      const percentage = position / width;

      // Update all other instances
      isUpdatingFromSync = true;
      instances.forEach(otherInstance => {
        if (otherInstance !== instance) {
          updateInstancePosition(otherInstance, percentage, width);
        }
      });
      isUpdatingFromSync = false;
    });

    observer.observe(slider, {
      attributes: true,
      attributeFilter: ['style']
    });

    // Track when this instance starts/stops sliding
    imgCompare.addEventListener('mousedown', () => { instance.isSliding = true; });
    imgCompare.addEventListener('touchstart', () => { instance.isSliding = true; });

    window.addEventListener('mouseup', () => { instance.isSliding = false; });
    window.addEventListener('touchend', () => { instance.isSliding = false; });
  });

  function updateInstancePosition(instance, percentage, width) {
    const position = percentage * width;

    instance.overlayImage.style.clipPath = `inset(0 ${width - position}px 0 0)`;
    instance.slider.style.left = position + 'px';
  }
}
